import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Load the favicon and the .htaccess file
import '!file-loader?name=[name].[ext]!./images/favicon.png';
import 'file-loader?name=.htaccess!./.htaccess'; // eslint-disable-line import/extensions
import '@fountain/ripple/styles';

import { ThemeProvider } from '@fountain/fountain-ui-components';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ConnectedRouter } from 'connected-react-router';
import { setupOpenApiClient } from 'openapi';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import ErrorBoundary from 'components/ErrorBoundary';
import { WxCopilotLayoutProviderConnected } from 'components/GlobalNav/context';
import { HireUniversalSearch } from 'components/UniversalSearch';
import WxCueRootHost from 'components/WxCueRootHost';
import App from 'containers/App';
import LanguageProvider from 'containers/LanguageProvider';
import { PostHogRootProvider } from 'containers/PostHogProvider';
import { domainMeta } from 'utils/domainMeta';
import history from 'utils/history';
import { posthogEnvironment } from 'utils/posthogEnvironment';
import { initSentry } from 'utils/sentry';
import theme from 'theme';

import configureStore from './configureStore';

// Before the store and the first render, so a failure in either is reported.
initSentry();

// Create redux store with history
const initialState = {};
const store = configureStore(initialState, history, {});
const MOUNT_NODE = document.getElementById('app');
const root = createRoot(MOUNT_NODE);
// Module scope keeps the object stable, so the root proxy is built once.
const POSTHOG_ROOT_PROPERTIES = {
  product: 'hire',
  ui: 'recruiter',
  environment: posthogEnvironment,
};

setupOpenApiClient();

const render = () => {
  root.render(
    <Provider store={store}>
      <PostHogRootProvider properties={POSTHOG_ROOT_PROPERTIES}>
        <ThemeProvider theme={theme}>
          <CssBaseline>
            <LanguageProvider>
              <ConnectedRouter history={history}>
                <ErrorBoundary>
                  <WxCopilotLayoutProviderConnected>
                    {/*
                      Cue panel surface — mounted ONCE outside <App /> so it
                      survives every route change. <App /> only owns trigger
                      placements; they toggle this surface via the shared
                      Zustand store inside the wx-system UMD bundle.
                      See HRAI-1928 / HRAI-1929 for the architectural fix.
                    */}
                    <WxCueRootHost />
                    <HireUniversalSearch />
                    <App />
                  </WxCopilotLayoutProviderConnected>
                </ErrorBoundary>
              </ConnectedRouter>
            </LanguageProvider>
          </CssBaseline>
        </ThemeProvider>
      </PostHogRootProvider>
    </Provider>,
  );
};

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  // React 18: a createRoot root re-renders in place — there is no
  // unmountComponentAtNode step, and unmounting the root here would discard it.
  module.hot.accept(['./i18n', 'containers/LanguageProvider', 'containers/App'], () => {
    render();
  });
}

render();

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
// if (NODE_ENV === 'production') {
//   require('offline-plugin/runtime').install(); // eslint-disable-line global-require
// }
